import { render } from "./Despachos.vue?vue&type=template&id=25958fb0&scoped=true"
import script from "./Despachos.vue?vue&type=script&lang=js"
export * from "./Despachos.vue?vue&type=script&lang=js"

import "./Despachos.vue?vue&type=style&index=0&id=25958fb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25958fb0"]])

export default __exports__